import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import App from 'components/App';
import ErrorBoundary from 'components/Global/ErrorBoundary';
import history from './history';
import configureStore from './configureStore';
import register, { unregister } from './registerServiceWorker';
import 'normalize.css';
import { startChatViewing } from 'utils/chatViewing';
import { startPushClickListener } from 'utils/pushNotifications';
import { startInstallPromptCapture } from 'utils/installPrompt';
import { startPushSound } from 'utils/playNotificationSound';
const initialState = {};
const store = configureStore(initialState, history);
const MOUNT_NODE = document.getElementById('root');

startChatViewing();
startPushClickListener();
startInstallPromptCapture();
startPushSound();

const Root = () => (
  <ErrorBoundary fullPage>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  </ErrorBoundary>
);

if (process.env.NODE_ENV === 'development') {
  register();
  ReactDOM.render(<Root />, MOUNT_NODE);
  if (module.hot) {
    module.hot.accept('components/App', () => {
      ReactDOM.render(<Root />, MOUNT_NODE);
    });
  }
} else {
  unregister();
  ReactDOM.render(<Root />, MOUNT_NODE);
}
